'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var AccessController = require('./access-controller');

var IPFSAccessController =
/*#__PURE__*/
function (_AccessController) {
  _inherits(IPFSAccessController, _AccessController);

  function IPFSAccessController(ipfs) {
    var _this;

    _classCallCheck(this, IPFSAccessController);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IPFSAccessController).call(this));
    _this._ipfs = ipfs;
    return _this;
  }

  _createClass(IPFSAccessController, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(address) {
        var dag, obj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Transform '/ipfs/QmPFtHi3cmfZerxtH9ySLdzpg1yFhocYDZgEZywdUXHxFU'
                // to 'QmPFtHi3cmfZerxtH9ySLdzpg1yFhocYDZgEZywdUXHxFU'
                if (address.indexOf('/ipfs') === 0) address = address.split('/')[2];
                _context.prev = 1;
                _context.next = 4;
                return this._ipfs.object.get(address);

              case 4:
                dag = _context.sent;
                obj = JSON.parse(dag.toJSON().data);
                this._access = obj;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log("ACCESS ERROR:", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      return function load(_x) {
        return _load.apply(this, arguments);
      };
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var hash, access, dag;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                access = JSON.stringify(this._access, null, 2);
                _context2.next = 4;
                return this._ipfs.object.put(new Buffer(access));

              case 4:
                dag = _context2.sent;
                hash = dag.toJSON().multihash.toString();
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log("ACCESS ERROR:", _context2.t0);

              case 11:
                return _context2.abrupt("return", hash);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      return function save() {
        return _save.apply(this, arguments);
      };
    }()
  }]);

  return IPFSAccessController;
}(AccessController);

module.exports = IPFSAccessController;